import { OfferCardWide } from '@sravni/creditselection-react/lib/OfferCard';
import { Avatar, Icon, Space, Transition, Typography } from '@sravni/react-design-system';
import { ArrowDown } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React, { type ReactElement, useState } from 'react';

import { pluralizeCredits } from 'shared/lib/pluralize';
import type { IVitrinsOffersCardProps } from 'shared/ui/VitrinsOffersCard';

import styles from './VitrinsOffersCard.module.scss';

export const VitrinsOffersCard: FC<IVitrinsOffersCardProps> = ({
  otherOffers = [],
  title,
  subtitle,
  summary,
  img,
  controls,
  children,
  isGrayCard,
}) => {
  const [isActiveShowMore, setIsActiveShowMore] = useState(false);
  const countOffers = otherOffers.length;
  const isMobile = useIsMobile();

  return (
    <OfferCardWide
      withControlsMobileBorder={false}
      className={cn(
        styles.card,
        { [styles.grayCard]: isGrayCard },
        countOffers ? styles.extendedCard : styles.simpleCard,
      )}
      title={title}
      subtitle={subtitle}
      icon={
        img ? (
          <Avatar
            src={img}
            className={styles.logo}
          />
        ) : (
          (null as unknown as ReactElement)
        )
      }
      summary={summary}
      badges={null}
      controls={controls}
      info={
        countOffers > 0 ? (
          <Space
            size={8}
            onClick={() => setIsActiveShowMore(!isActiveShowMore)}
            direction="vertical"
            className={styles.pointer}
          >
            <Space
              justify={isMobile ? 'center' : 'end'}
              size={4}
              align="center"
            >
              <Typography.Text
                size={14}
                className="h-color-D60"
              >
                {isActiveShowMore ? 'Свернуть' : `Еще ${countOffers} ${pluralizeCredits(countOffers)}`}
              </Typography.Text>

              <Icon
                size={16}
                icon={<ArrowDown className={cn(styles.arrow, { [styles.rotate]: isActiveShowMore })} />}
              />
            </Space>

            <Transition.Collapse visible={isActiveShowMore}>
              <Space
                size={20}
                className={styles.otherOffers}
                direction="vertical"
              >
                {children}
              </Space>
            </Transition.Collapse>
          </Space>
        ) : null
      }
    />
  );
};
